<template>
    <div class="modal fade" id="editPointModal" tabindex="-1" role="dialog" aria-labelledby="editPointModalTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editPointModalTitle">Edit point</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="isBusy == true" class="alert alert-primary">Updating point, please wait...</div>
                    <form class="form">
                        <div class="form-group">
                            <label for="pointName">Point name/label:</label>
                            <input class="form-control" id="pointName" type="text" v-model="pointName" />
                        </div>
                        <div class="form-group">
                            <label for="lat">Latitude:</label>
                            <input class="form-control" id="lat" type="text" v-model="lat" />
                        </div>
                        <div class="form-group">
                            <label for="lon">Longitude:</label>
                            <input class="form-control" id="lon" type="text" v-model="lon" />
                        </div>
                    </form>                    
                </div>
                <div class="modal-footer">
                    <button :disabled="isBusy == true" type="button" class="btn btn-primary" @click="editPointClicked">Edit point</button>
                    <button :disabled="isBusy == true" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                
                </div>
            </div>
        </div>
    </div>        
</template>

<script>

import $ from '@/lib/JQuery.js'
import logger from '@/lib/logger.js'

export default {
    name: 'EditPointDialog',
    data() {
        return {
            lat: 0,
            lon: 0,
            pointName: '',
            isBusy: false,
            serviceController: null,
            pointID: ''
        }
    },
    methods: {
        setServiceController(serviceController) {
            this.serviceController = serviceController
        },
        show(lat, lon, pointName, pointID) {
            this.lat = lat.toFixed(4)                    
            this.lon = lon.toFixed(4)
            this.pointName = pointName
            this.pointID = pointID

            $(this.$refs.modal).modal('show')
        },
        editPointClicked() {
            this.isBusy = true
            this.serviceController.editPoint(this.pointID, this.lat, this.lon, this.pointName, (success) => 
            { 
                this.isBusy = false 
                if (success)
                    $(this.$refs.modal).modal('hide')
            })
        }
    }
}
</script>

<style>
.color-list .color-item {
    display: inline-block; 
    padding: 8px;
    border: 4px solid white;
    border-radius: 4px;
}

.color-list .color-item.selected {
    border: 4px solid #00aaff;
}
</style>
